// assets/image-loader.worker.js

const addProtocol = (url) => {
  if (url && url.startsWith('//')) {
    return 'https:' + url;
  }
  return url;
};

self.onmessage = async function (e) {
  const { urls, colorKey } = e.data;
  
  // 【修复点】增加防御性判断
  // 如果 urls 不存在，或者不是数组，直接返回，防止报错
  if (!urls || !Array.isArray(urls) || urls.length === 0) {
    // console.warn('[Worker] No valid URLs received for key:', colorKey);
    return; 
  }
  
  const CONCURRENT_LIMIT = 6; 
  
  const downloadImage = async (rawUrl) => {
    const url = addProtocol(rawUrl);
    try {
      const response = await fetch(url, { mode: 'cors' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      return { url: rawUrl, objectUrl, success: true };
    } catch (error) {
      return { url: rawUrl, objectUrl: rawUrl, success: false };
    }
  };

  for (let i = 0; i < urls.length; i += CONCURRENT_LIMIT) {
    const chunk = urls.slice(i, i + CONCURRENT_LIMIT);
    const promises = chunk.map(url => downloadImage(url));
    const chunkResults = await Promise.all(promises);
    
    self.postMessage({
      type: 'chunk_loaded',
      colorKey,
      images: chunkResults
    });
  }

  self.postMessage({ type: 'all_loaded', colorKey });
};